module.exports = __webpack_public_path__ + "static/img/subpages.98a83b58.svg";